import {
  createReducer,
  createSetValueAction,
  FETCH_KEY,
  setValueReducer,
} from "../../../common/redux-helper";

export const Types = {
  SetValue: "write/SetValue",
  FetchPost: "write/FetchPost",
  FetchCreatePost: "write/FetchCreatePost",
  FetchUpdatePost: "write/FetchUpdatePost",
  FetchAllSeries: "write/FetchAllSeries",
  FetchCreateSeries: "write/FetchCreateSeries",
  FetchCreateTempPost: "write/FetchCreateTempPost",
  FetchCreateTempPostContinue: "write/FetchCreateTempPostContinue",
  FetchTempPost: "write/FetchTempPost",
  FetchDeleteTempPost: "write/FetchDeleteTempPost",
  FetchCreateSeriesImage: "write/FetchCreateSeriesImage",
  FetchDeleteSeriesImage: "write/FetchDeleteSeriesImage"
};

export const actions = {
  setValue: createSetValueAction(Types.SetValue),
  fetchPost: ({ id }) => ({
    type: Types.FetchPost,
    id,
  }),
  fetchUpdatePost: ({ postId,
    postName,
    hashtags,
    postDescription,
    postContent,
    postThumbnail,
    permission,
    seriesOriId,
    seriesOriName,
    seriesName,
    imageIds,
    videoIds,
    tempId }) => ({
      type: Types.FetchUpdatePost,
      postId,
      postName,
      hashtags,
      postDescription,
      postContent,
      postThumbnail,
      permission,
      seriesOriId,
      seriesOriName,
      seriesName,
      imageIds,
      videoIds,
      tempId,
    }),
  fetchCreatePost: ({
    postName,
    hashtags,
    postDescription,
    postContent,
    postThumbnail,
    permission,
    seriesName,
    imageIds,
    videoIds,
    tempId,
  }) => ({
    type: Types.FetchCreatePost,
    postName,
    hashtags,
    postDescription,
    postContent,
    postThumbnail,
    permission,
    seriesName,
    imageIds,
    videoIds,
    tempId,
  }),
  fetchCreateTempPost: ({
    postId,
    tempId,
    postName,
    hashtags,
    postDescription,
    postContent,
    postThumbnail,
    permission,
    seriesName,
    imageIds,
    videoIds,
  }) => ({
    type: Types.FetchCreateTempPost,
    postId,
    tempId,
    postName,
    hashtags,
    postDescription,
    postContent,
    postThumbnail,
    permission,
    seriesName,
    imageIds,
    videoIds,
  }),
  fetchCreateTempPostContinue: ({
    postId,
    tempId,
    postName,
    hashtags,
    postDescription,
    postContent,
    postThumbnail,
    permission,
    seriesName,
    imageIds,
    videoIds,
  }) => ({
    type: Types.FetchCreateTempPostContinue,
    postId,
    tempId,
    postName,
    hashtags,
    postDescription,
    postContent,
    postThumbnail,
    permission,
    seriesName,
    imageIds,
    videoIds,
  }),
  fetchAllSeries: () => ({
    type: Types.FetchAllSeries,
  }),
  fetchCreateSeries: ({ seriesName }) => ({
    type: Types.FetchCreateSeries,
    seriesName,
  }),
  fetchTempPost: ({ id, postId }) => ({
    type: Types.FetchTempPost,
    id,
    postId,
  }),
  fetchDeleteTempPost: ({ id }) => ({
    type: Types.FetchDeleteTempPost,
    id,
    [FETCH_KEY]: id
  }),
  fetchCreateSeriesImage: ({ imageId, fileName, seriesName }) => ({
    type: Types.FetchCreateSeriesImage,
    imageId,
    fileName,
    seriesName
  }),
  fetchDeleteSeriesImage: ({ seriesName }) => ({
    type: Types.FetchDeleteSeriesImage,
    seriesName
  }),
};
export const INITINAL_STATE = {
  post: null,
  postName: "",
  postContent: "",
  hashtag: [],
  postDescription: "",
  postThumbnail: "",
  permission: "public",
  seriesName: "",
  seriesThumbnail: "",
  seriesList: [],
  imageList: [],
  videoList: [],
  thumbnailId: "",
  postType: "post",
  tempId: "",
  txnCmpt: false,
  isFetching: false,
};

const reducer = createReducer(INITINAL_STATE, {
  [Types.SetValue]: setValueReducer,
});
export default reducer;
